function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".circleCancela{fill:#d56868;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2310.846 -488.917)"
}, /*#__PURE__*/React.createElement("path", {
  className: "circleCancela",
  d: "M2324.1,490.81a11.357,11.357,0,1,1-11.357,11.357A11.37,11.37,0,0,1,2324.1,490.81m0-1.893a13.25,13.25,0,1,0,13.25,13.25,13.25,13.25,0,0,0-13.25-13.25Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2319.67 497.751)"
}, /*#__PURE__*/React.createElement("path", {
  className: "circleCancela",
  d: "M2346.7,525.751a.943.943,0,0,1-.669-.277l-6.94-6.94a.946.946,0,0,1,1.338-1.339l6.941,6.94a.946.946,0,0,1-.67,1.616Z",
  transform: "translate(-2338.817 -516.918)"
}), /*#__PURE__*/React.createElement("path", {
  className: "circleCancela",
  d: "M2339.764,525.751a.946.946,0,0,1-.669-1.616l6.94-6.94a.947.947,0,0,1,1.339,1.339l-6.941,6.94A.943.943,0,0,1,2339.764,525.751Z",
  transform: "translate(-2338.817 -516.918)"
})));

var SvgCircleCancel = function SvgCircleCancel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.5,
    height: 26.5,
    viewBox: "0 0 26.5 26.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleCancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circleCancel.529e1b99.svg";
export { ForwardRef as ReactComponent };